import type { GlowingSlotLook } from "../../../../../render/materials/slotLook";
import { ColorField } from "../../ColorField/ColorField";
import { SliderField } from "../../SliderField/SliderField";

interface GlowControlsProps {
  slotLook: GlowingSlotLook;
  onChange: (look: GlowingSlotLook) => void;
}

export function GlowControls({ slotLook, onChange }: GlowControlsProps) {
  return (
    <>
      <ColorField label="Color" value={slotLook.color} onChange={(color) => onChange({ ...slotLook, color })} />
      <SliderField
        label="Strength"
        value={slotLook.strength}
        min={0}
        max={20}
        step={0.1}
        onChange={(strength) => onChange({ ...slotLook, strength })}
      />
    </>
  );
}
